import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Euro } from "lucide-react";

export const FinancesHeader = () => {
  return (
    <Card className="shadow-card">
      <CardHeader>
        <CardTitle className="text-2xl text-center flex items-center justify-center gap-2">
          <Euro className="w-6 h-6 text-primary" />
          Dashboard Financiero
        </CardTitle>
      </CardHeader>
      <CardContent>
        <p className="text-center text-muted-foreground">
          Gestión completa de facturación y pagos de actividades extraescolares.
        </p>
      </CardContent>
    </Card>
  );
};